import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const amazonas: HCConfig = {
         appName: 'Saúde AM Digital',
         hcId: '',
         isPublic: true,
         uf: 'AM',
         config: {
           trackingId: 'G-KDYDB4VRSB',
           domain: 'app.saudeamdigital.am.gov.br',
           domainKey: 'appAmazonasDomainUrl',
           reactDomainKey: 'appAmazonasDomainReactUrl',
           hcParam: 'amazonas',
           clientDomainHeader: 'saudeamdigital',
           govBrClientId: 'cuidar-piaui-gov-pi',
           supportChatKey:
             'NWViZWIzNjYtZDA4ZS00Y2M4LThmODUtMGYzZDE5YTUyOWMyOmU4YmM0YjQwMjY4NTQ2ODFkZDM1ZDhmMDI3NWRjYTc4YTU2NTg3MjJjZXNwMDA3MG4yZ0FsQ0dzYzExS0lTOE9uejNtY3dvRmg1SzhvRDJqcWc=',
         },
         assets: {
           logo: HCConfigAssets.mainLogo('amazonas', 'main-logo.svg'),
           uploadExternalFilesLogo: HCConfigAssets.uploadExternalFilesLogo('amazonas'),
           preloaderLogo: HCConfigAssets.preloaderLogo('amazonas'),
           favicon: HCConfigAssets.favicon('amazonas'),
         },
         links: {
           site: 'https://app.saudeamdigital.am.gov.br',
           termsOfUse: 'https://saudeamdigital.am.gov.br/termos-de-uso-amazonas.html',
           policyPrivacy: 'https://saudeamdigital.am.gov.br/politica-de-privacidade-amazonas.html',
           playstore: 'https://play.google.com/store/apps/details?id=com.ptm.amazonas',
           appstore: 'https://apps.apple.com/br/app/saúde-am-digital/id6742512883',
         },

         dataDeletion: {
           name: 'Saúde AM Digital',
           slug: 'amazonas',
           agreementTermsUrl: 'https://saudeamdigital.am.gov.br/termo-de-consentimento-exclusao-conta-amazonas.html',
           background: '#ffffff',
           logo: {
             src: HCConfigAssets.dataDeletionLogo('amazonas'),
             width: 180,
             height: 180,
           },
         },

         firstAccess: {
           name: 'Saúde AM Digital',
           city: 'Amazonas',
           slug: 'amazonas',
           emailDomain: '@saudeamdigital.am.gov.br',
           abbreviation: 'am',
           background: 'linear-gradient(45deg, #2d8efb, #034ea2 35%, #023f82)',
           logo: {
             src: HCConfigAssets.firstAccessLogo('amazonas'),
             width: 160,
             height: 150,
           },
         },

         mealPlan: {
           enableDocumentCreation: false,
           enableSendFiles: true,
           documentTypes: {
             showMealPlan: true,
             showTherapeuticPlan: false,
             showNursingPlan: false,
           },
         },

         routes: {
           firstAccess: '/first-access/amazonas',
         },

         features: [
           HCConfigFeatures.FIRST_ACCESS_REGISTER,
           HCConfigFeatures.PROCEDURES_APAC_SADT,
           HCConfigFeatures.REFERRAL_GUIDE,
           HCConfigFeatures.REQUEST_ATTENDANCE,
           HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
           HCConfigFeatures.PATIENT_INVITE_AND_EDIT_FORM_INCLUDE_CNS,
           HCConfigFeatures.ENABLE_FIRST_ACCESS,
           HCConfigFeatures.MANCHESTER_QUESTIONNAIRE,
           HCConfigFeatures.OPTIONAL_QUESTIONNAIRE_FOR_SECOND_OPINION,
           HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
         ],
         rules: [
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF_OR_EMAIL_OR_CNS,
           HCConfigRules.APPOINTMENT_MANAGEMENT,
           HCConfigRules.HC_HAS_CNES,
           HCConfigRules.BLOCK_REGISTRATION_WITH_OUT_OF_STATE_ZIPCODE,
           HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
           HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
         ],
       };
